module.exports = __webpack_public_path__ + "school3.07181ce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/school3.png
// module id = N72A
// module chunks = 0